module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/ko/2/2-450a87e291b0c8f56117ed724986dfa2.jpg";